import "./extended_details.css";
